import React from "react";
import { Field, ErrorMessage } from "formik";

type Props = {
    name: string;
    label?: string;
    type?: "text" | "number" | "email";
    as?: "textarea";
    maxLength?: number;
    placeholder?: string;
    inputClassName?: string;
};

// Formik form field component with a label and error message.
export const FormikField: React.FC<Props> = (props: Props) => {
    const { inputClassName, ...otherProps } = props;
    return (
        <>
            {props.label ? (
                <label htmlFor={props.name} className={"col-form-label"}>
                    {props.label}
                </label>
            ) : null}

            <Field
                {...otherProps}
                as={props.as}
                type={props.type}
                className={`form-control form-control-lg ${inputClassName ?? ""} ${props.as === "textarea" ? "large-input--textarea" : ""}`}
                name={props.name}
                placeholder={props.placeholder}
                maxLength={props.maxLength}
            />
            <ErrorMessage name={props.name} component="div" className="error-msg" />
        </>
    );
};
